import { render, staticRenderFns } from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=template&id=610a140e"
import script from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsEmployeeResponsibilityAssignmentHeader.vue?vue&type=style&index=0&id=610a140e&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports